import Vue from "vue";
import OTP from "./OTP.vue";

export function load() {
    const selector = "otp-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(OTP, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
